import React, {useState} from 'react';
import Actions from '../appFlux/action';
import user from '../assets/avatar-user.png';
import logo from '../assets/logo.png';
import {
  BrowserRouter as Router, Switch, Route, Link , useHistory
} from "react-router-dom";
import { SelectDD , ExternalDD } from '../common/dropdowns';

const aspirantDD = [
  {label: "Create Profile", value: "profile"},
  {label: "Assess Skills", value: "skills"},
  {label: "Build Resume", value: "resume"},
  {label: "Apply for Jobs", value: "applyJobs"},
  {label: "Browse Jobs", value: "jobs"},
  {label: "Job Watchlist", value: "watchlist"},
]

const employerDD = [
  {label: "Select Aspirants", value: "shortlist"},
  {label: "Post Jobs", value: "postJobs"},
  {label: "Host Competition", value: "hostComp"},
  {label: "Aspirant Watchlist", value: "watchlist"},
]

const Navbar = (props) => {
  const { store = {} } = props
  const { sidebarExpand = true } = store
  const setStore = () => {}
  var history = useHistory();
    const onNavigate = (o) => {
      history.push(o)
    }
  const onDDClick = (o) => {
    console.log("DD CLICK", o)
    history.push(o.value)
  }
  return (
    <nav className="header-navbar">
      <div className="ht-pct-100">
        <div className="navbar-logo">
          <img alt="EAI" src={logo} className="pd-r-5" style={{width: '60px', float: 'left'}} /> seeker             
        </div>
        <div className="v-align ht-pct-100">
          <div className="nav-navigate mg-l-20" onClick={() => onDDClick({value: ""})}>Home</div>
          <div className="nav-navigate d-flex">For Aspirants  
            <ExternalDD data={aspirantDD} onClick={onDDClick} right={true}>
              <i className="fa fa-caret-down home-dropdown-caret"></i>
            </ExternalDD>
          </div>
          <div className="nav-navigate d-flex">For Employers  
            <ExternalDD data={employerDD} onClick={onDDClick} right={true}>
              <i className="fa fa-caret-down home-dropdown-caret"></i>
            </ExternalDD>
          </div>
          <div className="nav-navigate d-flex">For Mentors  
            <ExternalDD data={employerDD} onClick={onDDClick} right={true}>
              <i className="fa fa-caret-down home-dropdown-caret"></i>
            </ExternalDD>
          </div>
          <div className="nav-navigate" onClick={() => onDDClick({value: "service"})}>Our Services</div>
          <div className="nav-navigate" onClick={() => onDDClick({value: "about"})}>About Us</div>
        
          <div className="navbar-container">
          <ul className="nav-right">
            <li className="pd-t-10">
              <a>
                <i className="far fa-bell"></i>
                <span className="header-badge bg-c-primary-active">4</span>
              </a>
            </li>              
            
            <li className="user-profile header-notification ">
              <a >
                <img className="img-radius-50" alt="Avatar" src={user}  />
                <i className="fa fa-chevron-down"></i>
              </a>
            </li>
          </ul>
        </div>
        </div>        
        
      </div>
    </nav>
  );
};

export default Navbar